import { BattleContractResponse } from '../model/Battle';
import { battleAxios } from '../module/HttpWebClient';

export async function getBattleContractInfo(battleCode: string): Promise<BattleContractResponse> {
  const url = `/battle/contract/share/${battleCode}`;
  const { data } = await battleAxios.get<BattleContractResponse>(url);
  return data;
}
